import { React, useState, useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../utils/authProvider";
import "../MRT/MRTStyle.css";

const DownTimeMRT = ({ downTimeData }) => {
  const navigate = useNavigate();
  const { getAuth, refreshCheck } = useAuthContext();

  const [xref, setXref] = useState([]);
  const [updatedColumns, setUpdatedColumns] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      accessorKey: "date",
      header: "Date",
      size: 120,
      sortingFn: (rowA, rowB, columnId) => {
        const a = new Date(rowA.getValue(columnId));
        const b = new Date(rowB.getValue(columnId));
        return a - b;
      },
    },
    { accessorKey: "siteName", header: "Site Name", size: 120 },
    { accessorKey: "hoursDown", header: "Hours Down", size: 120 },
    { accessorKey: "downCode", header: "Down Code", size: 120 },
    { accessorKey: "downcodeDescription", header: "Down Code Desc", size: 120 },
    { accessorKey: "remarks", header: "Remarks", size: 120 },
    { accessorKey: "lostOil", header: "Lost Oil", size: 120 },
    { accessorKey: "lostGas", header: "Lost Gas", size: 120 },
  ];
  const csvOptions = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    filename: `DataView_Export_${new Date().toISOString().slice(0, 10)}`, // ← custom filename
  };

  useEffect(() => {
    getXref();
    console.log("mrt start");
  }, []);
  useEffect(() => {
    if (xref.length > 0) {
      // Update column headers based on xref data
      const updatedColumns = columns.map((column) => {
        const xrefItem = xref.find((x) => x.key === column.accessorKey);
        if (xrefItem) {
          return { ...column, header: xrefItem.value };
        }
        return column;
      });
      setUpdatedColumns(updatedColumns);
    }
  }, [xref]);
  useEffect(() => {
    if (updatedColumns.length > 0) {
      console.log("updatedColumns", updatedColumns);
    }
    setLoading(false);
  }, [updatedColumns]);

  const getXref = async () => {
    setLoading(true);
    const authT = await getAuth();
    const options = {
      method: "GET",
      url: "https://api.pramsplus.com/xref-labels",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authT}`,
      },
    };
    if (authT !== false) {
      try {
        const response = await axios.request(options);
        // console.log("xref data", response.data);

        setXref(response.data);
      } catch (err) {
        console.log(err.response.status);
        if (err.response.status === 401) {
          const valid = await refreshCheck("getXref");
          if (valid === true) {
            console.log("Retrying getXref api call");
            getXref();
          } else if (valid === false) {
            console.log("all retries failed getXref");
            navigate("/login");
          }
        } else {
          console.log("Redirecting to login something went wrong in getXref");
          navigate("/login");
        }
        return;
      }
    }
    return;
  };
  const handleExportRows = (rows, updatedColumns) => {
    const visibleColumns = updatedColumns.filter(
      (col) =>
        col.getIsVisible() &&
        col.id && // ignore columns without valid id
        col.columnDef.header !== "Select" // ignore MRT's checkbox column
    );

    const csvOptionsWithHeaders = {
      ...csvOptions,
      headers: visibleColumns.map((col) => col.columnDef.header),
    };

    const csvExporter = new ExportToCsv(csvOptionsWithHeaders);

    const exportData = rows.map((row) =>
      visibleColumns.reduce((acc, col) => {
        const rawValue = row.original[col.id];
        acc[col.id] =
          rawValue === null || rawValue === undefined || rawValue === ""
            ? "-"
            : rawValue;
        return acc;
      }, {})
    );

    csvExporter.generateCsv(exportData);
  };

  const showChart = () => {
    console.log("showChart");
    return (
      <MaterialReactTable
        columns={updatedColumns}
        data={downTimeData}
        initialState={{
          density: "compact",
          columnVisibility: {
            siteName: true,
            downCode: true,
            downcodeDescription: true,
            remarks: true,
            lostOil: true,
            lostGas: true,
          },
        }}
        enableRowSelection
        enableStickyHeader
        enablePagination={false}
        enableBottomToolbar={false}
        positionToolbarAlertBanner="bottom"
        muiTableContainerProps={{ sx: { maxHeight: "325px", width: "100%" } }}
        renderTopToolbarCustomActions={({ table }) => (
          <Box
            sx={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}
          >
            <Button
              color="primary"
              onClick={() =>
                handleExportRows(
                  table.getRowModel().rows,
                  table.getAllColumns()
                )
              }
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Export Data
            </Button>
            <Button
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
              onClick={() =>
                handleExportRows(
                  table.getSelectedRowModel().rows,
                  table.getAllColumns()
                )
              }
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              Export Selected Rows
            </Button>
          </Box>
        )}
      />
    );
  };

  return <>{loading === true ? null : showChart()}</>;
};

export default DownTimeMRT;
